import { render, staticRenderFns } from "./qr_code.vue?vue&type=template&id=f08a0e52&scoped=true"
import script from "./qr_code.vue?vue&type=script&lang=js"
export * from "./qr_code.vue?vue&type=script&lang=js"
import style0 from "./qr_code.vue?vue&type=style&index=0&id=f08a0e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08a0e52",
  null
  
)

export default component.exports